import React from "react"
import TableHeaderRow from "../../ui/TableHeaderRow"
import TableHeader from "../../ui/TableHeader"
import { useNavigate } from "react-router-dom"
import Table, { Row, Cell } from "../../ui/Table"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { selectAdvancedMode } from "../settings/slice"
import IDCopy from "../../ui/IDCopy"
import Timestamp from "../../ui/Timestamp"
import RSOInfo from "../rsos/RSOInfo"
import IDLink from "../../ui/IDLink"

const SamplesTable = ({ samples = [], filter, stickyHeader = true }) => {
  // User setting to show more details such as id's
  const advancedModeState = useSelector(selectAdvancedMode)
  // if filters apply to advancedMode columns we have to show them
  const advancedModeOverride =
    filter && (filter.pipeline_id || filter.id_cnts) ? true : false
  const advancedMode = advancedModeOverride
    ? advancedModeOverride
    : advancedModeState
  const navigate = useNavigate()
  const navigateTo = (id) => () => navigate(`/samples/${id}`)

  return (
    <Table>
      <TableHeaderRow sticky={stickyHeader}>
        {advancedMode && <TableHeader>ID</TableHeader>}
        <TableHeader>At</TableHeader>
        {advancedMode && (
          <TableHeader>Right Ascension (uncorrected)</TableHeader>
        )}
        <TableHeader>Right Ascension</TableHeader>
        {advancedMode && <TableHeader>Declination (uncorrected)</TableHeader>}
        <TableHeader>Declination</TableHeader>
        <TableHeader>Object</TableHeader>
        <TableHeader>Observation</TableHeader>
        {/*Actions*/}
        <TableHeader />
      </TableHeaderRow>
      {samples && (
        <tbody>
          {samples.map((sample) => (
            <Row key={sample.id} zebra>
              {advancedMode && (
                <Cell onClick={navigateTo(sample.id)}>
                  <IDCopy truncateTo={20} id={sample.id} showCopy={true} />
                </Cell>
              )}
              <Cell onClick={navigateTo(sample.id)}>
                <Timestamp utc={advancedMode} columnMode={true}>
                  {sample.at}
                </Timestamp>
              </Cell>
              {advancedMode && <Cell>{sample.uncorrected_ra}</Cell>}
              <Cell>{sample.ra}</Cell>
              {advancedMode && <Cell>{sample.uncorrected_dec}</Cell>}
              <Cell>{sample.dec}</Cell>
              <Cell>
                <RSOInfo id={sample.object_id} />
              </Cell>
              <Cell>
                <IDLink to={`/observations/${sample.derived_from}`}>
                  {sample.derived_from}
                </IDLink>
              </Cell>
            </Row>
          ))}
        </tbody>
      )}
    </Table>
  )
}

SamplesTable.propTypes = {
  samples: PropTypes.array, // the samples to render as a table
  filter: PropTypes.object, // If provided will be used to power the filters if not filters will not be shown
  setFilter: PropTypes.func, // If provided will be used to power the filters if not filters will not be shown
  stickyHeader: PropTypes.bool, // If true, table header is sticky
  hideFilters: PropTypes.bool, // If provided hides the filters for the table
}

export default SamplesTable
